<template>
  <div class="bg-secondary-1 py-2 px-1 board-radius">
    <div v-for="(detail, idx) in details" :key="idx">
      <div
        :class="`row mx-1 ${idx == 0 ? 'p-2 bg-white board-radius' : 'mt-2'}`"
      >
        <div
          v-for="item in detail"
          :key="item.label"
          :class="`${Boolean(item.cols) ? String(item.cols) : 'col-sm w-50'}`"
        >
          <div class="d-flex">
            <div
              v-if="item.mainIcon"
              class="d-flex align-items-center"
              :class="item.containerClass"
            >
              <span
                class="dot text-center d-flex justify-content-center align-items-center mt-n1"
              >
                <em class="color-white font-20" :class="item.icon" />
              </span>
              <span class="font-14" :class="item.dataClass">
                {{ item.data }}
              </span>
            </div>
            <em
              v-if="item.icon && !item.mainIcon"
              class="pt-1 mr-2 text-orange"
              :class="item.icon"
            />
            <div v-if="!item.mainIcon">
              <span class="font-12 color-gray-6">{{ item.label }}</span>
              <p class="font-14 color-black" :class="item.dataClass">
                {{ item.data }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Board',
  props: {
    details: {
      type: Array,
      required: true,
    },
    bgWhite: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style scoped>
.board-radius {
  border-radius: 4px;
}

.dot {
  background-color: #ff7058;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 45px;
  height: 43px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}

/* .orange-icon-badge-align {
  vertical-align: top;
} */
</style>
